import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/shared/services/form.service';
import { Global } from 'src/app/shared/global';
import { Router } from '@angular/router';
import { Client } from 'src/app/shared/models/client';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-educational-container',
  templateUrl: './educational-container.component.html',
  styleUrls: ['./educational-container.component.scss']
})
export class EducationalContainerComponent implements OnInit {
  @Input() source = '';
  @Input() title: string;  
  @Output() buttonSelectEvent = new EventEmitter<any>();
  userForm: FormGroup;
  client: Client = {} as Client;

  resetTitle: string;

  constructor(public formService: FormService, private router: Router, public global: Global, private userService: UserService) { 
    this.userForm = this.formService.userObjectForm;
  }

  ngOnInit(): void {
    if (this.source == 'userForm') {      
      this.resetTitle = this.title = 'Introduction';
    } else if(this.global.selectedEduCategoryTitle){
      this.title = this.global.selectedEduCategoryTitle;
    }

    console.log('title', this.title)

    /* if (this.source == 'medicare') {
      this.title = 'Medicare 101';
      // this.subTitle = "What happens ar Medicare age?"
      // this.bodyText = "Medicare is the federal health insurance program primarily for Americans age 65 and over. For those who are no longer working or covered by employer-sponsored health insurance, the program"
    } */

  }
  next() {
    this.getEducationalLessons();
  }

  getEducationalLessons() {
    console.log(this.formService.getRequestObject());
    console.log('this.formService.userObjectForm', this.formService.userObjectForm);
    console.log('this.formService.userObjectForm.value.firstName', this.formService.userObjectForm.value.firstName);
    this.client = this.formService.mappingFromUserObject(this.client);
    this.formService.updateClientForm(this.client);
    this.userService.post(Global.BASE_URL + Global.GET_EDUCATIONAL_LESSONS, this.formService.getRequestObject())
      .subscribe(resp => {
        console.log(resp);
        this.global.getEduLessonObj = resp;
        console.log('')
        this.global.userName = this.formService.userObjectForm.value.firstName;
        //this.global.eligibleMedicareRetirementYear = (65 - this.formService.userObjectForm.value.currentAge) + new Date().getFullYear();
        //this.global.yearsUntilEligibleMedicareRetirementYear = (65 - this.formService.userObjectForm.value.currentAge);
        // this.global.getEduLessonObj = JSON.parse(this.global.getEduLessonObj);
        this.router.navigate(['/lesson-categories'], { queryParams: { org: this.global.orgID } });

      })
      
  }

  back(): void {
    if (this.source == 'userForm') {
      this.router.navigate(['/'], { queryParams: { org: this.global.orgID } });
    } else { //if (this.source == 'medicare') {
      this.global.clearEducationSelections();
      this.router.navigate(['/lesson-categories'], { queryParams: { org: this.global.orgID } });
    }
  }
  
  returnedButtonSelection(data){
    console.log('returned selection', data);
    console.log('source', this.source);
    this.title = data;
    this.buttonSelectEvent.emit(data);
  }

}
